document.addEventListener("DOMContentLoaded", () => {
  $('#paginateBy').on('change', function(){
    var val = $(this).val();
    $.ajax({
      type: "POST",
      url: '/cart.js',
      data: {"attributes[pagination]": val},
      success: function(d){
        window.location.reload();
      },
      dataType: 'json'
    });
  });
  $('#paginateByMobile').on('change', function(){
    var val = $(this).val();
    $.ajax({
      type: "POST",
      url: '/cart.js',
      data: {"attributes[pagination]": val},
      success: function(d){
        window.location.reload();
      },
      dataType: 'json'
    });
  });
})